import { U8, F32 } from '../engine/typed-arrays.js';
import { mipLevelCount } from '../texture/mip-count.js';

const ENV_MAGIC = new U8([134, 22, 135, 150, 246, 214, 150, 54]);
function parseEnvFile(buffer) {
  const bytes = new U8(buffer);
  for (let i = 0; i < 8; i++) {
    if (bytes[i] !== ENV_MAGIC[i]) {
      throw new Error("Invalid .env file: bad magic");
    }
  }
  let pos = 8;
  while (pos < bytes.length && bytes[pos] !== 0) {
    pos++;
  }
  const jsonStr = new TextDecoder().decode(bytes.subarray(8, pos));
  pos++;
  const binaryStart = pos;
  const manifest = JSON.parse(jsonStr);
  const width = manifest.width;
  const mipCount = mipLevelCount(width, width);
  const irr = manifest.irradiance;
  const irradianceSH = new F32(27);
  const shKeys = ["x", "y", "z", "xx", "yy", "zz", "yz", "zx", "xy"];
  for (let i = 0; i < 9; i++) {
    const coeff = irr[shKeys[i]];
    irradianceSH[i * 3] = coeff[0];
    irradianceSH[i * 3 + 1] = coeff[1];
    irradianceSH[i * 3 + 2] = coeff[2];
  }
  const mipmaps = manifest.specular.mipmaps;
  const imageType = manifest.imageType || "image/png";
  const faceBlobs = [];
  for (const entry of mipmaps) {
    const start = binaryStart + entry.position;
    const slice = buffer.slice(start, start + entry.length);
    faceBlobs.push(new Blob([slice], { type: imageType }));
  }
  return { faceBlobs, irradianceSH, width, mipCount };
}

export { parseEnvFile };
//# sourceMappingURL=env-parse.js.map
